import styled from 'styled-components';
import { colors } from 'syf-component-library/defaultTheme';
import { chevronDownIcon } from '../../AlmeUtilities/Icons/ChevronDown';
export const SelectWrapper = styled.div `
  position: relative;
  width: ${props => props.width}em;
  height: ${props => props.height}em;
`;
export const CustomSelect = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: ${props => props.width}em;
  height: ${props => props.height}em;
  background-color: #fff;
  @media (hover: hover) {
    display: "block"};
  }
`;
export const NativeSelect = styled.select `
  position: absolute;
  width: ${props => props.width}em;
  height: ${props => props.height}em;
  top: 0;
  left: 0;
  margin: 0 !important;
  font-size: inherit !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: none;
  background-image: url(${props => chevronDownIcon(colors.mediumGrey)}) !important;
  background-repeat: no-repeat !important;
  background-size: 1em !important;
  background-position-x: 100% !important;
  background-position-y: 50% !important;

  @media (hover: hover) {
    &&:focus + ${CustomSelect} {
      display: none;
    }
  }
`;
export const CustomTrigger = styled.div `
  position: relative;
  width: 100%;
  height: ${props => props.height}em;
  margin:0;
  padding: calc(${props => props.height}em/4) 0;
  text-align: left;
  cursor: pointer;
  overflow-x: hidden;
  background-image: url(${props => chevronDownIcon(colors.mediumGrey)}) !important;
  background-repeat: no-repeat !important;
  background-size: 1em !important;
  background-position-x: 100% !important;
  background-position-y: 25% !important;
  overflow: unset;
  box-sizing: unset;
  line-height: 1.15;
`;
export const CustomSelectOptions = styled.div `
  position: absolute;
  top: ${props => props.top}em;
  left: 0;
  width: 100%;
  max-height: ${props => props.height}px;
  border: 1px solid #6f6f6f;
  background-color: #fff;
  z-index: 1;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  overflow-x: hidden;
`;
export const CustomSelectionOption = styled.div `
  margin: 0;
  min-width: ${props => props.width}em;
  padding: calc(${props => props.height}em/4) 0;
  text-align: left;
  background-color: ${props => props.isActive ? props.theme.hoverBackground : "#fff"};
  &&:hover {
    background-color: ${props => props.theme.hoverBackground};
  }
`;
